import {z} from "zod";

export const mongoObjectIdSchema = z.string().regex(/^[a-f\d]{24}$/i, "Expected a MongoDB ObjectId");
